import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_pathlessLayout/dashboard/gameSummary")({
    validateSearch: z.object({
        matchId: z.coerce.number().optional(),
    }),
    beforeLoad: ({ search }) => {
        throw redirect({
            to: "/dashboard/overview",
            search: { matchId: search.matchId },
            replace: true,
        });
    },
    component: () => null,
});
